import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/storage';

//components
import { createUser } from './userCheckAndRoll/CreateUser';
import { AddOrg } from './userCheckAndRoll/UserOrganization';
//import { newUserEmail } from './userCheckAndRoll/NewUserEmail';
//import { Authentication } from './outreach/Authentication';

export const signInWithGoogle = () => {

    const auth = firebase.auth();

    const provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope('profile')
    provider.addScope('email')
    
    // auth.signInWithPopup(provider);
    auth.signInWithPopup(provider).then(async function(result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        let token = result.credential.accessToken;
        var company= '';
        
        if(result.additionalUserInfo.profile.hd){
            company = result.additionalUserInfo.profile.hd
            // console.log(result)
            // console.log(token)
            // console.log(company)
            AddOrg(company, result, token)
        }else{
            company = result.additionalUserInfo.profile.email;
            AddOrg(company, result, token)
        }

        const handleCheckout = async() =>{
            firebase.firestore().collection('customers').doc(result.user.uid).get().then(
              function(doc)
              {
                if(doc.exists){
                  //console.log("document exists")
                } else{
                  var db = firebase.firestore();
        
                  var docRef =
                      db.collection('customers')
                      .doc(result.user.uid)
                      .collection('checkout_sessions')
              
                  var object = {
                    price: 'price_1IQil9DGIrW588V86JUPexpt',
                    success_url: window.location.origin,
                    cancel_url: window.location.origin,
                    metadata: {tokens: 1000},
                    mode: "subscription",
                    IdempotencyKey: "XBKifMkKaHzdvSnm",
                  }
              
                  docRef
                      .doc()
                      .set(object)
                      .then(function () {
                          //console.log('Document Added ');
                      })
                      .catch(function (error) {
                          console.error('Error adding document: ', error);
                      });
                }
              }
            )  
          }    

          const handleFreeTrial = async(authID) =>{

            var db = firebase.firestore();
    
            await db.collection('customers')
            .doc(authID)
            .collection('tokens')
            .doc(authID)
            .set({
            totalTokens: 10
            }).then(() =>{
    
            //put place to add to free trialed
                db.collection('freeTrial')
                .doc(authID)
                .set({
                    freeTrial: 'yes'
                })
            })
          }

          const handleOnboard = async(authID, result) =>{
            var db = firebase.firestore();

            await db.collection('onboards')
            .doc(authID)
            .set({
              onboarded: 'no',
              welcomeClicked: 'no',
              onboardDoneShown: 'no',
              copyMessageShown: 'no',
              messTypeShown: 'no',
              vPropShown: 'no',
              intShown: 'no',
              customInt: "no",
              fireShown: "no",
              copyShow: "no", 
              generateShown: 'no',
              createdAt: new Date(),
              email: result.additionalUserInfo.profile.email,
            })
          }

        //adding user
        await firebase.firestore().collection('users').doc(result.user.uid).get().then(function(doc) {
            if (doc.exists) {
                handleCheckout()
                //console.log("Document Exists")
                createUser(result, company, token)
                //console.log('doc exists')
            } else {
                handleCheckout()
                //console.log('in doesnt exist')
                let authID = result.user.uid
                handleFreeTrial(authID)
                // Where we will handle onboarding
                // checkForVProps(company)
                handleOnboard(authID, result)
                SaveSearchLastFive(company, result)
                //console.log("Document doesn't exist")
                //newUserEmail(result, company, token) //we need a manifest 
                createUser(result, company, token)
            }
        })
    }).then(()=> {
      //  Authentication()
    })
    .catch(function(error) {
      // Handle Errors here.
      let errorCode = error.code;
      console.log(errorCode)
      let errorMessage = error.message;
      console.log(errorMessage)
      // The email of the user's account used.
      let email = error.email;
      console.log(email)
      // The firebase.auth.AuthCredential type that was used.
      let credential = error.credential;
      console.log(credential)
      // ...
    });
};

const SaveSearchLastFive = (company, result) => {

  var newDoc =firebase
              .firestore()
              .collection('organizations')
              .doc(company)
              .collection('searchedContactLastFive')
              .doc(result.user.uid)
              .collection('searchedContact')
              .doc()

      newDoc.set({
              contactImg: '',
              contactFirstName: 'Elon',
              contactLastName: 'Musk',     
              contactName: 'Elon Musk',
              contactCompany: 'Tesla',
              contactRole: 'CEO',
              contactEducation: 'MIT',
              contactFieldOfStudy: 'Electric cars, Rockets',
              contactHeadline: 'I change the world with Rockets, Cars, and Doge',
              contactCity: 'Austin',
              contactLinkdinUrl: '',
              contactInterest: ['Rockets', 'Space', 'Cars'],
              contactContent: '',
              contactArticles: '',
              message: '',
              createdBy: result.additionalUserInfo.profile.email,
              authorID: result.user.uid,
              authorFirstName: result.additionalUserInfo.profile.given_name,
              authorLastName: result.additionalUserInfo.profile.family_name,
              authorCompany: company,
              createdAt: new Date(),
              docId: newDoc.id
          }).then(() =>{
            firebase
              .firestore()
              .collection('organizations')
              .doc(company)
              .collection('prospects')
              .doc(newDoc.id)
              .set({
                CreatedBy: result.additionalUserInfo.profile.email,
                Company: company,
                Linkedin: '',
                ProspectName: 'Elon Musk',
                ProspectCompany: 'Tesla',
                ProspectRole: 'CEO',
                ProspectInterest: ['Rockets', 'Space', 'Cars'],
                ProspectContent: '',
                contactImg: '',
                contactEducation: 'MIT',
                contactFieldOfStudy: 'Electric cars, Rockets',
                contactHeadline: 'I change the world with Rockets, Cars, and Doge',
                contactCity: 'Austin',
                createdAt: new Date(),
                AuthorID: result.user.uid,
                AuthorFirstName: result.additionalUserInfo.profile.given_name,
                AuthorLastName: result.additionalUserInfo.profile.family_name,
                MessageApproved: 'No',
                MessageSent: 'No',
                InterestPreAi: '',
                CreatedfromApp: "Yes",
                CreatedfromCext: "No",
              })
          }
          )
}

// const checkForVProps = (company) =>{

//   var newDoc = firebase
//               .firestore()
//               .collection('organizations')
//               .doc(company)
//               .collection('valueProps')
//               .doc('onboarding')

//               newDoc.get()
//               .then((docSnapshot) => {
//                 if (docSnapshot.exists) {
//                   console.log('document has value props')
//                 } else {
//                   newDoc.set({
//                     Pain: `It's tough to write effective sales messaging. Outbound teams struggle to write personalized messaging that's concise and engaging quickly, so they settle for templates that 99% of prospects ignore.`,
//                     Title: `Bound - Generic`,
//                     ValueProp: `Bound writes engaging and personalized outreach in just seconds. With better messaging generated by AI, Bound helps your team book more meetings, in less time, automatically.`
//                   })
//                 }
//               })

// }